/**
 * Returns a promise that stays pending until the page is restored from
 * the browser's back-forward cache (bfcache). Use as the return value
 * of a submit handler after triggering navigation — keeps the form in
 * "submitting" state while the browser navigates away, and resolves
 * naturally if the user returns via bfcache.
 */
export const pendingNavigation = (): Promise<void> =>
    new Promise((resolve) => {
        window.addEventListener(
            "pageshow",
            (e) => {
                if (e.persisted) resolve();
            },
            { once: true },
        );
    });
